
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useSearchParams } from "react-router-dom"

export const WaterSupplyDistributionNetworkPreventiveWorkExportData = (props) => {
    const { ExcelData, name, searchName,Date } = props

    const [searchParams] = useSearchParams()
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={11} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Navi Mumbai Municipal Corporation</th>
                </tr>
                <tr>
                    <th colSpan={11} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>WATER SUPPLY DEPARTMENT</th>
                </tr>
                <tr>
                    <th colSpan={11} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - {(ExcelData && ExcelData.table && ExcelData.table[0].projectName) ? (ExcelData && ExcelData.table && ExcelData.table[0].projectName) : '-'}</th>
                </tr>
                <tr>
                    <th colSpan={11} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Report Name: {name}</th>
                </tr>
                <tr>
                    <th colSpan={11} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Date:- {Date ? Date : '-'} </th>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th rowSpan={3} style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th colspan={2} style={{ textAlign: "center" }} className='new_grid'>Water Consumption</th>
                        <th colspan={4} style={{ textAlign: "center" }}>Supply Scheduled Time</th>
                        <th colspan="2" style={{ textAlign: "center" }}>Quantified Of Critical Point</th>
                        <th colspan="2" style={{ textAlign: "center", borderRight: "1px solid black"  }}>No Of Critical Point</th>
                        {/* <th colspan="1">Action</th> */}
                    </tr>
                    <tr style={{backgroundColor: '#254462', color: "#fff", border: '1px solid white'}}>
                        {/* <th rowSpan={2}>Sr No.</th> */}
                        <th rowSpan={2}>Metered</th>
                        <th rowSpan={2}>Un Metered</th>
                        <th colspan="2" style={{ textAlign: "center" }} className='new_grid'>Stipulated</th>
                        <th colspan="2" style={{ textAlign: "center" }} className='new_grid'>Actual</th>
                        <th rowSpan={2}>Required</th>
                        <th rowSpan={2}>Actual</th>
                        <th rowSpan={2}>Normal</th>
                        <th rowSpan={2} style={{ borderRight: "1px solid black" }}>Affected</th>
                        {/* <th rowSpan={2}>Edit  Delete</th> */}
                    </tr>
                    <tr style={{backgroundColor: '#254462', color: "#fff", border: '1px solid white'}}>
                        <th>Morning</th>
                        <th>Evening</th>
                        <th>Morning</th>
                        <th>Evening</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr style={{ width: "100%", border: "1px solid black" }}>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.consumptionMetered ? item.consumptionMetered : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.consumptionUnMetered ? item.consumptionUnMetered : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.stipulatedMorning ? item.stipulatedMorning : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.stipulatedEvening ? item.stipulatedEvening : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.actualMorning ? item.actualMorning : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.actualEvening ? item.actualEvening : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.criticalPointsRequired ? item.criticalPointsRequired : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.criticalPointsActual ? item.criticalPointsActual : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.criticalPointsNormal ? item.criticalPointsNormal : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.criticalPointsAffected ? item.criticalPointsAffected : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>

            </table>
        </div>
    )
}